import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title, Span } from '../../components/Shared/TitleSuccess';
import { copyFor } from '../../copy/copy';
import { ActionTypes } from '../../utils/enums';

const TitleComponent = props => (
    <Title>
        {props.useLocalRepresentative && !props.isSinglePerson ? (
            <Span>{copyFor('feedback', 'representatives', 'call')}</Span>
        ) : (
            <Span>
                {copyFor('feedback', 'singleRecipient', 'call', undefined, {
                    recipientName: props.recipientName
                })}
            </Span>
        )}
    </Title>
);

TitleComponent.propTypes = {
    recipientName: PropTypes.string,
    useLocalRepresentative: PropTypes.bool,
    isSinglePerson: PropTypes.bool
};

const CallAction = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            titleComponent={
                <TitleComponent
                    recipientName={props.recipientName}
                    useLocalRepresentative={props.useLocalRepresentative}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

CallAction.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    recipientName: PropTypes.string.isRequired,
    useLocalRepresentative: PropTypes.bool,
    isSinglePerson: PropTypes.bool
};

export default connect(
    state => ({
        recipientName: state.call.successInfo.recipientName,
        peopleCount: state.call.completeCall.endUsersCount
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        useLocalRepresentative: state.call.successInfo.useLocalRepresentative,
        isSinglePerson: state.call.successInfo.isSinglePerson
    }),
    {},
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Call) return true;

            return next === prev;
        }
    }
)(CallAction);
